import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useTournament } from "@/lib/TournamentContext";

const COMPETITIONS = [
  { to: "/predict", label: "Main League", testid: "sub-nav-predict", key: "main_league" },
  { to: "/survivor", label: "Survivor", testid: "sub-nav-survivor", key: "survivor" },
  { to: "/bracket", label: "Bracket", testid: "sub-nav-bracket", key: "bracket" },
  { to: "/bracket-ko", label: "Bracket KO", testid: "sub-nav-bracket-ko", key: "bracket_ko" },
  { to: "/fantasy", label: "Fantasy XI", testid: "sub-nav-fantasy", key: "fantasy" },
  { to: "/bonus", label: "Bonus", testid: "sub-nav-bonus", key: "bonus_questions" },
];

export default function CompetitionLayout() {
  const { active } = useTournament();
  const visible = COMPETITIONS.filter((c) => active?.competitions?.[c.key] ?? true);

  return (
    <>
      <div className="sticky top-[65px] z-30 nav-surface backdrop-blur-xl border-b border-white/10">
        <div className="px-4 md:px-8 py-2 flex items-center gap-1 overflow-x-auto no-scrollbar">
          <span className="label-tag mr-4 hidden md:inline">Competitions</span>
          {visible.map((c) => (
            <NavLink
              key={c.to}
              to={c.to}
              data-testid={c.testid}
              className={({ isActive }) =>
                `px-4 py-2 text-xs uppercase tracking-[0.18em] border whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-accent border-primary-accent text-white"
                    : "border-zinc-800 text-zinc-400 hover:border-white/30 hover:text-white"
                }`
              }
            >
              {c.label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </>
  );
}
